import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import {Button} from 'rmwc/Button';
import ResourceComponent from '../learning_resource_admin/ResourceComponent';
import ReactGA from 'react-ga';

class ArchiveSection extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
            userActivity: false,
    		data:{
                resourceDetails: []
    		},
            errorMsg: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()

        this.props.history.push('/portal/app/learning_resources/my_learning_plan')
    }

    handleResourceFetch = () => {
        let data = Object.assign({}, this.state.data)

        let activityType = 'archive'
        let targetMonth = 'all'
        let fetchArchives = `learning_resource/my_learning_path/${activityType}/${targetMonth}`
        return api.getUserResponse(this.props.user.accessToken, fetchArchives)
        .then((result) => {
            if (result.status === 'success') {
                if(result.data.no_target_date !== undefined) {
                    data.resourceDetails = result.data.no_target_date
                }
                else {
                    data.resourceDetails = result.data
                }
                this.setState({data: data, userActivity: true})
            }
            else if (result.status == 'no_activity'){
                this.setState({userActivity: false})
            }
            else {
                this.setState({errorMsg: 'The server encountered an error while fetching. Please try again after sometime.'})
            }
        })
    }

    componentDidMount(){
        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview('/archives');

        this.handleResourceFetch()
    }

    render () {
        let resourceComponent
        let displayComponent
        let handleBackAction = this.handleBackAction
        let handleResourceFetch = this.handleResourceFetch

        if(this.state.data.resourceDetails.length>0){
            resourceComponent = (
                <Grid className="opportunity-list-item">
                    <GridCell span="12">
                        <Typography use="subtitle1"> The resources you have archived are: </Typography>
                    </GridCell>
                    {this.state.data.resourceDetails.map(function(resource){
                        return (
                            <GridCell span = "12" key = {resource.id}>
                                <Card style={{padding: '0px'}}>
                                    <ResourceComponent resourceId = {resource.id}
                                        resourceName = {resource.name}
                                        resourceAuthor = {resource.author}
                                        resourceDescription = {resource.description}
                                        resourceLink = {resource.resource_link}
                                        resourceLanguage = {resource.language}
                                        languageId = {resource.language_id}
                                        resourceComplexity = {resource.complexity}
                                        complexityId = {resource.complexity_id}
                                        resourceStatus = {resource.active}
                                        resourceType = {resource.resource_type}
                                        onHandleResourceFetch = {handleResourceFetch}
                                        isAdmin = {false}
                                        bookmarkFeature = {false} 
                                        archiveFeature = {true}
                                    />
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }
        else {
            resourceComponent = (
                <Grid className="opportunity-list-item">
                    <GridCell span="12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="subtitle1">You haven't archived any resources.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }
    	return (
            <div>
                <Grid className="opportunity-list-item">
                    <GridCell span = "12">
                        <Card style={{padding: '0px'}}>
                            <Grid>
                                <GridCell span = "11">
                                    <Typography use="headline5">My Archives Section</Typography>
                                </GridCell>
                                <GridCell span = "1">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                </GridCell>
                            </Grid>
                        </Card>
                    </GridCell>
                </Grid>
                {resourceComponent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveSection);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/ArchiveSection.jsx